import { Translate } from 'next-translate';

type localizeErrorMessagesType = (
  fields: Record<string, any>,
  errors: any,
  t: Translate,
) => Record<string, { message: string }>;

export const localizeErrorMessages: localizeErrorMessagesType = (fields, errors, t) =>
  Object.keys(errors).reduce((accumulator, currentFieldName) => {
    const errorType = errors[currentFieldName].type;
    accumulator[currentFieldName] = {
      message: t(errorType, { fieldName: fields[currentFieldName] }),
    };
    return accumulator;
  }, {});
